import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  HeaderContainer,
  Nav,
  Logo,
  LogoImage,
  NavLink,
  ButtonGroup,
  HeaderInner,
  WhitePaperButton,
  WhitePaperBackground,
  WhitePaperBackgroundImage,
  WhitePaperContent,
  WhitePaperTitle,
  WhitePaperSubtitle,
  ScrollProgressBar,
  HamburgerButton,
  MobileNav,
  MobileNavLink,
  CloseButton
} from "../styles/components/HeaderStyles";

function Header() {
  const { t, i18n } = useTranslation();
  const [hideHeader, setHideHeader] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (currentScrollY / scrollHeight) * 100;
      
      setScrollProgress(progress);
      setHideHeader(currentScrollY > lastScrollY && currentScrollY > 1);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const toggleLanguage = () => {
    const newLang = i18n.language === "ko" ? "en" : "ko";
    i18n.changeLanguage(newLang);
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <HeaderContainer hide={hideHeader}>
        <HeaderInner>
          <Logo href="/" aria-label="TITAN'S TAP Home">
            <LogoImage 
              src="https://framerusercontent.com/images/YfB8pfpf5i1eL8fIx93dhiGqQU.png" 
              alt="TITAN'S TAP Logo"
            />
          </Logo>
          <Nav>
            <NavLink href="#introducing" onClick={(e) => handleNavClick(e, 'introducing')}>Introducing</NavLink>
            <NavLink href="#keyfeatures" onClick={(e) => handleNavClick(e, 'keyfeatures')}>KeyFeatures</NavLink>
            <NavLink href="#gods" onClick={(e) => handleNavClick(e, 'gods')}>Gods</NavLink>
            <NavLink href="#roadmap" onClick={(e) => handleNavClick(e, 'roadmap')}>RoadMap</NavLink>
          </Nav>
          <ButtonGroup>
            <WhitePaperButton
              href="https://developments-organization-1.gitbook.io/titanstap-whitepaper"
              target="_blank"
              rel="noopener"
            >
              <WhitePaperBackground>
                <WhitePaperBackgroundImage 
                  src="https://framerusercontent.com/images/FslH4Np8O4kSQa2FOqm6StHwTU.svg" 
                  alt=""
                />
              </WhitePaperBackground>
              <WhitePaperContent>
                <WhitePaperTitle>TITAN'S TAP</WhitePaperTitle>
                <WhitePaperSubtitle>WHITE PAPER</WhitePaperSubtitle>
              </WhitePaperContent>
            </WhitePaperButton>
            <HamburgerButton onClick={toggleMenu} isOpen={isMenuOpen}>
              <span />
              <span />
              <span />
            </HamburgerButton>
          </ButtonGroup>
        </HeaderInner>
      </HeaderContainer>
      <MobileNav isOpen={isMenuOpen}>
        <CloseButton onClick={toggleMenu} aria-label="Close Menu" />
        <MobileNavLink href="#introducing" onClick={(e) => handleNavClick(e, 'introducing')}>Introducing</MobileNavLink>
        <MobileNavLink href="#keyfeatures" onClick={(e) => handleNavClick(e, 'keyfeatures')}>KeyFeatures</MobileNavLink>
        <MobileNavLink href="#gods" onClick={(e) => handleNavClick(e, 'gods')}>Gods</MobileNavLink>
        <MobileNavLink href="#roadmap" onClick={(e) => handleNavClick(e, 'roadmap')}>RoadMap</MobileNavLink>
      </MobileNav>
      <ScrollProgressBar progress={scrollProgress} hide={hideHeader} />
    </>
  );
}

export default Header;
